<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <div class="container-fluid">
            <span class="d-flex align-items-center">
                <router-link class="navbar-brand" to="/hoshitsuki">
                    <img src="@/hoshitsuki/assets/logo_hoshitsuki.png" class="logo" alt="ホシツキ">
                </router-link>
                <router-link to="/hoshitsuki" class="btn btn-sm btn-light"><i class="bi bi-house"></i>もどる</router-link>
            </span>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="/guide/hoshitsuki-for-students.pdf"><i class="bi bi-question-circle"></i> {{ $t('使い方') }}</a>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.hoshitsuki.auth.is_signed_in">
                        <a class="nav-link dropdown-toggle" href="#" id="systemDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-person-circle"></i> <span v-if="$store.state.hoshitsuki.auth.student_name">{{ $store.state.hoshitsuki.auth.student_name }} さん</span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="systemDropdown">
                            <li>
                                <a class="nav-link text-black" href="#" @click="signOut()">ログアウト</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="container-main container-md container-full-height container-middle">
        <div class="container-main container-md">
            <div class="card">
                <div class="card-header">
                    <h2 class="mb-0"><i class="bi bi-file-text text-primary"></i> 小テスト</h2>
                </div>
                <div class="card-body">

                    <h3 class="text-primary mb-3 mt-5">Q1. {{ $t('星の明るさや色について、正しいものを選びましょう。') }}</h3>
                    <p><span class="text-secondary">ア．</span>{{ $t('どの星も明るさや色は同じ') }}</p>
                    <p><span class="text-secondary">イ．</span>{{ $t('星によって明るさや色は違う') }}</p>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_1"
                            :options="options_2"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_1, options_2) }}</span>
                        </span>
                    </div>

                    <h3 class="text-primary mb-3 mt-5">Q2. {{ $t('月の見え方について、正しいものを選びましょう。') }}</h3>
                    <p><span class="text-secondary">ア．</span>{{ $t('月は日によって見える形が同じ') }}</p>
                    <p><span class="text-secondary">イ．</span>{{ $t('月は日によって見える形が違う') }}</p>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_2"
                            :options="options_2"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_2, options_2) }}</span>
                        </span>
                    </div>

                    <h3 class="text-primary mb-3 mt-5">Q3. {{ $t('月の動きについて、正しいものを選びましょう。') }}</h3>
                    <p><span class="text-secondary">ア．</span>月は東からのぼって南の空をとおり西にうごく</p>
                    <p><span class="text-secondary">イ．</span>月は西からのぼって東の空をとおり南にうごく</p>
                    <p><span class="text-secondary">ウ．</span>月は東からのぼって北の空をとおり西にうごく</p>
                    <p><span class="text-secondary">エ．</span>月は西からのぼって南の空をとおり東にうごく</p>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_3"
                            :options="options_4"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_3, options_4) }}</span>
                        </span>
                    </div>

                    <h3 class="text-primary mb-3 mt-5">Q4. {{ $t('満月はこのあとどちらに動くか、ア〜エから選びましょう。') }}</h3>
                    <div class="text-center">
                        <img src="@/hoshitsuki/assets/quiz1-4.jpg" alt="図1">
                    </div>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_4"
                            :options="options_4"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_4, options_4) }}</span>
                        </span>
                    </div>

                    <h3 class="text-primary mb-3 mt-5">Q5. {{ $t('星の見える位置や並び方について正しいものを選びましょう。') }}</h3>
                    <p><span class="text-secondary">ア．</span>{{ $t('星の見える位置は時間がたってもかわらない。星の並び方はかわる。') }}</p>
                    <p><span class="text-secondary">イ．</span>{{ $t('星の見える位置は時間がたつとかわる。星の並び方もかわる。') }}</p>
                    <p><span class="text-secondary">ウ．</span>{{ $t('星の見える位置は時間がたってもかわらない。星の並び方もかわらない。') }}</p>
                    <p><span class="text-secondary">エ．</span>{{ $t('星の見える位置は時間がたつとかわる。星の並び方はかわらない。') }}</p>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_5"
                            :options="options_4"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_5, options_4) }}</span>
                        </span>
                    </div>

                    <h3 class="text-primary mb-3 mt-5">Q6. {{ $t('オリオン座はこのあとどちらに動くか、ア〜エから選びましょう。') }}</h3>
                    <div class="text-center">
                        <img src="@/hoshitsuki/assets/quiz1-6.jpg" alt="図2">
                    </div>
                    <div class="text-center mt-3" v-if="quiz">
                        <form-radio
                            v-if="quiz.is_submitted === 0"
                            v-model="quiz.answer_6"
                            :options="options_4"
                        ></form-radio>
                        <span class="px-3 py^1 border-bottom" v-else>
                            A. <span class="text-secondary">{{ which(quiz.answer_6, options_4) }}</span>
                        </span>
                    </div>
                    <div class="text-end mt-3">
                        <template v-if="quiz">
                            <button v-if="quiz.is_submitted === 0" class="btn btn-primary" @click="submit">{{ $t('提出') }}</button>
                            <button v-else class="btn btn-outline-primary" disabled>{{ $t('提出') }}ずみ</button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Quiz from '@/shared/models/entities/hoshitsuki/quiz';
import FormRadio from '@/shared/components/form/FormRadio';

export default {
    name: 'PageQuiz',
    components: {
        FormRadio,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
        'signOut',
    ],
    data() {
        return {
            quiz: null,
            options_2: [
                {key: 1, label: 'ア'},
                {key: 2, label: 'イ'},
            ],
            options_4: [
                {key: 1, label: 'ア'},
                {key: 2, label: 'イ'},
                {key: 3, label: 'ウ'},
                {key: 4, label: 'エ'},
            ],
        }
    },
    mounted() {
        this.startScreenLoading();
        this.$http.get(process.env.VUE_APP_BASE_URI + '/hoshitsuki/quiz/1')
        .then((response) => {
            this.quiz = new Quiz(response.data);
        })
        .finally(() => {
            this.endScreenLoading();
        });
    },
    methods: {
        submit() {
            if (this.quiz.answer_1 === null) {
                this.showErrorMessage('Q1に' + this.$t('回答') + 'していません');
                this.question = 1;
                return;
            }
            if (this.quiz.answer_2 === null) {
                this.showErrorMessage('Q2に' + this.$t('回答') + 'していません');
                this.question = 2;
                return;
            }
            if (this.quiz.answer_3 === null) {
                this.showErrorMessage('Q3に' + this.$t('回答') + 'していません');
                this.question = 3;
                return;
            }
            if (this.quiz.answer_4 === null) {
                this.showErrorMessage('Q4に' + this.$t('回答') + 'していません');
                this.question = 4;
                return;
            }
            if (this.quiz.answer_5 === null) {
                this.showErrorMessage('Q5に' + this.$t('回答') + 'していません');
                this.question = 5;
                return;
            }
            if (this.quiz.answer_6 === null) {
                this.showErrorMessage('Q6に' + this.$t('回答') + 'していません');
                this.question = 6;
                return;
            }

            this.quiz.is_submitted = 1;
            this.startScreenLoading();
            this.$http.put(process.env.VUE_APP_BASE_URI + '/hoshitsuki/quiz/1', this.quiz)
            .then(() => {
                this.showMessage(this.$t('提出') + 'しました。')
            })
            .finally(() => {
                this.endScreenLoading();
            });
        },
        which(value, options) {
            return options.find(option => option.key === value).label;
        }
    },
}
</script>

<style scoped>
.container-full-height {height: calc(100vh - 2.875rem);}
.container-middle {display: flex; flex-direction: column; justify-content: center;}
</style>
